<template>
  <div v-click-outside="onBlur">
    <div class="search d-flex">
      <input
          v-model="searchValue"
          class="search__input"
          type="text"
          name=""
          placeholder="Orchid..."
          aria-label="Orchid..."
          autocomplete="off"
          @input="onHandle"
          @focus="onFocus"
          @click="onClick"
      />
      <button
          class="btn search__btn"
          @click="onClick"
      >
        <img src="@/assets/images/icons/search-icon.svg" alt="">
      </button>
    </div>

    <search-form-result
      v-if="showSearchResult"
      :result="plants"
    />
  </div>
</template>

<script>
import {useAuthStore, useEnabledStore} from "@/stores"
import PlantLibraryService from "@/service/PlantLibraryService.js"
import SearchFormResult from "@/components/layouts/header/parts/SearchFormResult.vue"
import _debounce from 'lodash.debounce'
import vClickOutside from 'click-outside-vue3'
import { showModalById } from "@/helpers/modalHelper.js"

export default {
  components: { SearchFormResult },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data () {
    return {
      searchValue: null,
      searchIsFocused: false,
      plants: [],
      authStore: useAuthStore(),
      enabledStore: useEnabledStore()
    }
  },
  computed: {
    showSearchResult () {
      const { searchValue, searchIsFocused } = this
      return searchValue && searchIsFocused
    },
    isAuth() {
      return this.authStore.isAuth
    },
    isPortalTypeBooks() {
      return this.enabledStore.isPortalTypeBooks;
    }
  },
  methods: {
    findPlants: _debounce(async function () {
      if (this.searchValue.length <= 2 || !this.isAuth || this.isPortalTypeBooks) return

      try {
        const { data } = await PlantLibraryService.getAllPlants({ name: this.searchValue})
        this.plants = data.data.items
        this.searchIsFocused = true
      } catch (error) {}
    }, 300),
    onHandle(event) {
      this.searchValue = event.target.value.replace(/[<>{}"'`$();]/g, '').replace(/\s+/g, ' ').trim()
      this.findPlants()
    },
    onFocus() {
      this.searchIsFocused = true
    },
    onBlur () {
      this.searchIsFocused = false
      this.$emit('onBlur')
    },
    onClick() {
      if (!this.isAuth) {
        showModalById('getAccessModal')
      }
    }
  }
};
</script>

<style
  lang="scss"
  scoped
>
.search {
  position: relative;
  border-radius: 40px;
  padding: 2px 44px 2px 16px;
  border: 2px solid $black;
  width: 100%;
  max-width: 100%;
  height: 36px;

  .search__input {
    flex: 1;
    border: 0;
    outline: 0;

    &::placeholder {
      color: $black;
    }
  }

  .search__btn {
    border-radius: 40px;
    background: $black;
    padding: 2px 6px;
    width: 36px;
    height: 28px;
    position: absolute;
    right: 3px;
    top: 2px;
    bottom: 3px;
  }

  @media (max-width: $breakpoint-lg) {
    .search__btn {
      top: 3px;
    }
  }
  @media (max-width: $breakpoint-sm) {
    .search__btn {
      top: 2px;
    }
  }
}
</style>